let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5CS4Y")).then(() => parcelRequire('2P5hx'));